import { reactive,computed } from 'vue';
export default {
  components: {
  },
  props: {
    data:{
      type: Array,
      default:[
        {
          name:"Success",
          color:"#FCD9AF",
          value:20
        },
        {
          name:"Fail",
          color:"#ff0000",
          value:4
        },
      ],
    },
  },
  setup(props) {//emit 傳到複層_emit('update:{function}', val)
    const {data} = props;
    //data
    let state = reactive({
    })
    // methods
    const Data = computed(() => {
      var _data = data;
      var total = 0;
      for(var a = 0;a<_data.length;a++){
        total+=_data[a].value
      }
      var x = 0;
      for(a = 0;a<_data.length;a++){
        _data[a].ratio = Math.round(_data[a].value/total*100);
        _data[a].x1 = "0%";
        _data[a].x2 = x + _data[a].ratio+"%";
        if(a == _data.length-1){
          _data[a].x2 = "100%"
        }
        x += _data[a].ratio;
      }
      var reversed=[];
      for(a = _data.length-1;a>=0;a--){
        reversed.push(_data[a]);
      }
      return reversed
    })
    //mounted
    return {
      state,
      Data,
    }
  }
}